import { render, staticRenderFns } from "./GoalSelect.vue?vue&type=template&id=a5e6eba4&scoped=true"
import script from "./GoalSelect.vue?vue&type=script&lang=ts"
export * from "./GoalSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e6eba4",
  null
  
)

export default component.exports